import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { PageHeader } from 'teacher-ui-client/components/page-header/index'
import { t } from 'ember-intl'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { InputSearch } from 'teacher-ui-client/components/base/input-search'
import { BigBooksSearch } from 'teacher-ui-client/components/big-books/search'
import { BigBookLevelSelect } from 'teacher-ui-client/components/big-books/big-book-level-select'
import type BigBooksRoute from 'teacher-ui-client/subscription-type/big-books/route'
import type BigBooksController from 'teacher-ui-client/subscription-type/big-books/controller'
import { range, debounce } from 'lodash'

interface Signature {
  Element: HTMLDivElement
  Args: {
    model: ModelFor<BigBooksRoute>
    controller: BigBooksController
  }
}

export class BigBooksPage extends Component<Signature> {
  // Had to debounce the keyword updating (w/ lodash) as reactiveweb debounce isn't currently working for tracked fns
  updateKeywords = debounce((keywords: string) => {
    this.args.controller.keywords = keywords
  }, 500)

  get bigBookLevelRange(): string[] {
    switch (this.args.model.subscriptionType) {
      case SubscriptionType.Reading:
        return range(1, 34 + 1).map((l) => l.toString())
      case SubscriptionType.Maths:
        return ['kindergarten', 'grade_1', 'grade_2']
      default:
        return []
    }
  }

  <template>
    <div class="grow" ...attributes>
      <PageHeader>
        <:title>
          <h1>
            {{t "pages.bigBooks.title"}}
          </h1>
        </:title>
      </PageHeader>
      <div class="mx-auto max-w-(--breakpoint-lg) space-y-6">
        <div class="mx-4 flex justify-center">
          <InputSearch
            class="mx-auto w-80"
            @themeKey={{themeKey @model.subscriptionType}}
            @value={{@controller.keywords}}
            @updateValue={{this.updateKeywords}}
          />
        </div>
        <BigBookLevelSelect
          @subscriptionType={{@model.subscriptionType}}
          @bigBookLevelRange={{this.bigBookLevelRange}}
        />
        <BigBooksSearch
          @keywords={{@controller.keywords}}
          @bigBookLevel={{@controller.bigBookLevel}}
          @bigBookLevelRange={{this.bigBookLevelRange}}
          @subscriptionType={{@model.subscriptionType}}
        />
      </div>
    </div>
  </template>
}

export default RouteTemplate(BigBooksPage)
